import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div`
  flex-grow: 1;
  max-width: var(--prompt-max-width, 100%);
  margin: 0 auto;
  width: 100%;
`;

const GridLayout = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill, 
    minmax(var(--card-min-width), 1fr)
  );
  gap: 8px;
  margin: 0 auto ${rem(8)};
`;

const Tip = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${rem(8)};
  margin-bottom: ${rem(24)};
  padding: 0 ${rem(16)};
  text-align: center;

  .icon {
    margin-right: ${rem(8)};
    vertical-align: -2px;
  }
`;

const Nav = styled.aside`
  display: flex;
  justify-content: space-between;
  width: var(--prompt-showcase-nav-width);
  margin: 0 auto ${rem(8)};
`;

const NavButton = styled.span<{ direction?: 'back' | 'forward' }>`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: ${rem(8)};
  transform: rotateZ(${({ direction }) => (direction === 'forward' ? 180 : 0)}deg);
`;

const CategoryTitle = styled.h4`
  color: inherit;
  display: flex;
  align-items: center;
  font-weight: 600;
  margin: 0;
  min-height: ${rem(48)};
  padding: ${rem(8)} ${rem(16)};
  text-align: center;
  text-wrap: balance;
  user-select: none;
`;

export default {
  GridLayout,
  Nav,
  NavButton,
  CategoryTitle,
  Tip,
  Wrapper
};
